import { render, staticRenderFns } from "./DigitalService.vue?vue&type=template&id=6b009bcb&"
import script from "./DigitalService.vue?vue&type=script&lang=js&"
export * from "./DigitalService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports